"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PriceTypes_1 = require("../Enum/PriceTypes");
class ValuationPriceExtractor {
    /**
     * @inheritDoc
     */
    getActualPrice(valuation, meta) {
        const priceEvaluations = valuation.getValuationData().getPriceEvaluations();
        if (!priceEvaluations) {
            return null;
        }
        const metas = meta ? `:${meta}` : '';
        const finalType = PriceTypes_1.PriceTypes.FINAL + metas;
        const wholeSaleType = PriceTypes_1.PriceTypes.WHOLESALE + metas;
        // From the prices list, keep only the ones of interest, final and wholesale
        const goodPrices = priceEvaluations.filter((price) => {
            return price.getEvaluationType() === finalType || price.getEvaluationType() === wholeSaleType;
        });
        if (!goodPrices.length) {
            return null;
        }
        // Set the correct price, final if it exists, wholesale otherwise.
        const final = goodPrices.find(price => price.getEvaluationType() === finalType);
        if (final) {
            return final.getEvaluationValue();
        }
        return goodPrices[0].getEvaluationValue();
    }
}
exports.default = ValuationPriceExtractor;
